import { Instagram, Facebook } from "lucide-react";
import { SOCIALS } from "@/lib/api";

const ICONS = { instagram: Instagram, facebook: Facebook };

const WaIcon = () => <span className="brand-mask h-4 w-4" style={{ WebkitMaskImage: "url(/brands/whatsapp.svg)", maskImage: "url(/brands/whatsapp.svg)" }} />;

export const Socials = ({ className = "" }) => (
  <div className={`flex flex-wrap gap-2 ${className}`}>
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.type] || WaIcon;
      return (
        <a key={s.id} data-testid={`social-${s.id}`} href={s.url} target="_blank" rel="noreferrer" aria-label={`${s.type} ${s.label}`} className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 text-bone transition-colors duration-300 hover:border-brand hover:bg-brand hover:text-cream">
          <Icon className="h-4 w-4" />
          <span className="text-sm">{s.label}</span>
        </a>
      );
    })}
  </div>
);
